import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { decryptText, encryptText } from "../../utils/utils";

interface FinancialYearState {
    selectedYear: string | null;
}

const storedYear = localStorage.getItem("financialYear");
const initialState: FinancialYearState = {
    selectedYear: storedYear ? decryptText(storedYear) : null,
};

const financialYearSlice = createSlice({
    name: "financialYear",
    initialState,
    reducers: {
        setFinancialYear: (state, action: PayloadAction<string>) => {
            const encryptedYear = encryptText(action.payload);
            localStorage.setItem("financialYear", encryptedYear);
            state.selectedYear = action.payload;
        },
        clearFinancialYear: (state) => {
            localStorage.removeItem("financialYear");
            state.selectedYear = null;
        },
    },
});

export const { setFinancialYear, clearFinancialYear } = financialYearSlice.actions;
export default financialYearSlice.reducer;
